import React, { useEffect } from "react";
import OneSignal from "react-onesignal";
import "./assets/css/DarkTheme.css";
import "bootstrap/dist/css/bootstrap.css";
import "material-icons/iconfont/material-icons.css";
import "./assets/css/Default.css";
import { Scrollbars } from "react-custom-scrollbars-2";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import NgLoading from "./apps/Components/NgLoading";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import apps from "./apps";
import PrivateRoute from "./Utils/PrivateRoute";
import PublicRoute from "./Utils/PublicRoute";

import { useDispatch, useSelector } from "react-redux";
import { validAuthToken } from "./redux/actions/Auth.Action";
import Error404 from "./apps/Components/Error404";
import { LazyLoadComponent } from "react-lazy-load-image-component";
import SocketComponent from "./sockets/SocketComponent";

function App() {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(validAuthToken());
    if (process.env.REACT_APP_ONESIGNAL !== "false") {
      OneSignal.init({ appId: process.env.REACT_APP_ONESIGNAL });
    }
  }, []);
  const Loading = useSelector((state) => state.Auth.Loading);
  const LockScreen = useSelector((state) => state.Auth.lockPop);
  return (
    <React.Fragment>
      <div
        className="preloader"
        style={{ display: `${Loading ? "" : "none"}` }}
      >
        <NgLoading />
      </div>
      <LazyLoadComponent>
        <Scrollbars style={{ height: "100vh" }}>
          {!LockScreen ? (
            <Router>
              <Switch>
                <PublicRoute path="/" exact>
                  <Redirect to="/Auth" />
                </PublicRoute>
                <PublicRoute path="/Auth" component={apps.Auth.Auth} />
                <PrivateRoute path="/Dashboard" component={apps.Dashboard} />
                <div className="posBody">
                  <PrivateRoute path="/POS" component={apps.POS} />
                  <PrivateRoute path="/Bar" component={apps.Bar} />
                  <PrivateRoute path="/Kitchen" component={apps.Kitchen} />
                  <PrivateRoute path="/Waiter" component={apps.Waiter} />
                  <PrivateRoute path="/CakeRoom" component={apps.CakeRoom} />
                </div>
                <Route path="/MyTableOrder" component={apps.TableOrder} />
                <Route path="*">
                  <Error404 />
                </Route>
              </Switch>
            </Router>
          ) : (
            <apps.Auth.LockScreen />
          )}
          <ToastContainer />
        </Scrollbars>
        <SocketComponent />
      </LazyLoadComponent>
    </React.Fragment>
  );
}

export default App;
